const CURRENT_LOCATION = location.origin;
const CURRENT_DOMAIN = localStorage.getItem('current_kampus_domain');

export const API_URL = `${CURRENT_DOMAIN || CURRENT_LOCATION}/api/v1`;
export const API_BASE = CURRENT_LOCATION;
export const API_URL_MOBILE = `${CURRENT_DOMAIN || CURRENT_LOCATION}/ms/auth/api`;

const ENV_API_V2 = import.meta.env?.PUBLIC_APP_API_V2 || '';
export const API_V2 = ENV_API_V2;

let ENV_API_TQ = import.meta.env?.PUBLIC_APP_API_TQ || '';

if (location.hostname.includes('stage.kampus.local')) ENV_API_TQ = 'https://51.250.110.153';

export const API_TQ = ENV_API_TQ;

const ENV_API_V3 = `${CURRENT_DOMAIN || CURRENT_LOCATION}/api/v3`;

export const API_URL_V3 = `${ENV_API_V3}`;
